var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scope-more-entrance"
  }, [_c('el-row', {
    staticClass: "text-center"
  }, _vm._l((_vm.subMenu), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: item.value
        }
      }
    }, [_c('div', {
      staticClass: "item-entrance"
    }, [_c('i', {
      staticClass: "item-entrance-tag",
      class: _vm.iconMap[item.value]
    }), _vm._v(" "), _c('span', {
      staticClass: "item-entrance-title"
    }, [_vm._v(_vm._s(item.text))])])])], 1)
  }), 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d763678c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/more/entrance.vue
// module id = null
// module chunks = 